import { FC } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import SecurityIcon from '@mui/icons-material/Security';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { Divider, ListItemIcon } from '@mui/material';
import { Logout, Settings } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { getOrganization, getUserInfo } from 'redux/reducers/user/selectors';
import { stringAvatar } from 'utils/stringAvatar';
import { getUserImage } from 'utils/getUserImage';
import { TUserMenuProps } from './types';

export const UserMenu: FC<TUserMenuProps> = ({
	anchorElUser,
	handleCloseUserMenu,
	handleLogout,
}) => {
	const userinfo = useSelector(getUserInfo);
	const organization = useSelector(getOrganization);

	return (
		<Menu
			sx={{ mt: '45px' }}
			id="menu-appbar"
			anchorEl={anchorElUser}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			keepMounted
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			open={Boolean(anchorElUser)}
			onClose={handleCloseUserMenu}
		>
			<Box sx={{ mt: '-8px', p: '14px 16px 14px 16px', minWidth: 280, bgcolor: '#dddddd' }}>
				<Box sx={{ display: 'flex', alignItems: 'start' }}>
					<Avatar
						src={getUserImage(userinfo?.email || '')}
						{...stringAvatar(userinfo?.fullName || '')}
					/>
					<Box sx={{ pl: '10px' }}>
						<Typography
							textAlign="left"
							variant="h6"
							component="div"
							// color="white"
						>
							{userinfo?.fullName ?? ''}
						</Typography>
						<Typography
							textAlign="left"
							color="text.secondary"
							variant="body2"
							// color="white"
						>
							{userinfo?.email ?? ''}
						</Typography>
						<Typography
							textAlign="left"
							variant="body1"
							// color="white"
						>
							{organization?.group_name ?? ''}
						</Typography>
					</Box>
				</Box>{' '}
			</Box>
			{/* <MenuItem disabled sx={{ opacity: '1!important' }}>
      <ListItemIcon>
        <BusinessCenterIcon fontSize="small" />
      </ListItemIcon>
      <Typography textAlign="left" variant="body1">
        {organization?.group_name ?? ''}
      </Typography>
    </MenuItem>
    <Divider variant="middle" /> */}

			{/* <MenuItem onClick={handleLogout} sx={{ pt: '14px' }}>
				<ListItemIcon>
					<HistoryEduIcon fontSize="small" />
				</ListItemIcon>
				<Typography textAlign="center">Contract</Typography>
			</MenuItem>
			<Divider variant="middle" />
			<MenuItem onClick={handleLogout}>
				<ListItemIcon>
					<Settings fontSize="small" />
				</ListItemIcon>
				<Typography textAlign="center">General Settings</Typography>
			</MenuItem>
			<MenuItem onClick={handleLogout}>
				<ListItemIcon>
					<NotificationsNoneIcon fontSize="small" />
				</ListItemIcon>

				<Typography textAlign="center">Notification Settings</Typography>
			</MenuItem>
			<MenuItem onClick={handleLogout}>
				<ListItemIcon>
					<SecurityIcon fontSize="small" />
				</ListItemIcon>

				<Typography textAlign="center">Security Settings</Typography>
			</MenuItem>
			<Divider variant="middle" /> */}
			<MenuItem onClick={handleLogout}>
				<ListItemIcon>
					<Logout fontSize="small" />
				</ListItemIcon>
				<Typography textAlign="center">Logout</Typography>
			</MenuItem>
		</Menu>
	);
};
